import {
  eventBus
} from '../eventbus'

export default {
  data: function () {
    return {
      cache: null,
      processing: false
    }
  },
  mounted: function () {
    var vm = this;
    setTimeout(function () {
      vm.startPolling();
    }, 4000)
  },
  methods: {
    START_DOWNLOAD: function () {
      var preferences = this.$root.preferences;

      if (preferences.useOffline && preferences.persistence == "Auto" && !this.processing) {
        // se non esiste già, crea la collezione per l'indice della cache
        this.cache = this.cacheCollection();

        this.processing = true;
        // se l'uso offline è abilitato e il download delle info cataloghi deve essere "Automatico", devo iterare ogni catalogo per scaricare sia loki che risorse
        var catalogList = this.$root.dataReferences.getCollection("catalogs")
        try {
          // (scarico prima i dati del catalogo corrente)
          catalogList.data.sort(function (a, b) {
            if (a.id == this.$root.root_index) {
              return -1
            } else if (b.id == this.$root.root_index) {
              return 1
            } else {
              // il resto in ordine alfabetico
              return a.name < b.name ? -1 : 1;
            }
          }, this);
        } catch (err) {
          console.log("Error sorting catalog list")
          console.log(err)
        }
        catalogList = catalogList.data;
        // console.log(catalogList)
        // inizio la ricorsione dei cataloghi (index 0)
        this.offlineCatalogsIter(catalogList, 0);
      }
    },
    offlineCatalogsIter(list, index) {
      if (index >= list.length) {
        // ____ FINE RICORSIONE ____
        this.processing = false;
        console.log("_FINE RICORSIONE_")
        return;
      } else {
        var cat = list[index];
        // per ogni catalogo in lista, se non esiste già, creo il record nell'indice della cache
        let cache_record = this.cacheRecord(cat);
        console.log(cache_record)

        // load catalog la invoco in ogni caso, che loaded_cat sia false o true..
        // nel secondo caso semplicemente risponderà la cache e avrò comunque il riferimento al loki del catalogo per iterare le risorse (immagini e/o documenti)
        this.loadCatalog(cache_record).then((res) => {
          //res riporta il riferimento al catalogo
          if (res) {
            // resolved TRUE
            // non ciclo i prodotti per scaricare le risorse se il flag non è abilitato
            if (this.$root.preferences.docCat) {
              var products = res.getCollection("products");

              // ___ promise per la risoluzione di tutte le risorse del catalogo ___
              var vm = this;
              var resourcePromise = new Promise(function (resolve, reject) {
                if (!cache_record.loaded_doc) {
                  // se è la prima volta che provo a scaricare le risorse di questo catalogo, last_doc sarà 0
                  if (cache_record.last_doc != 0) {
                    vm.$root.simpleNotification("info", {
                      title: "DEV",
                      message: 'Scaricamento "' + cache_record.name + '" in sospeso, ripreso a riga ' + cache_record.last_doc,
                    })
                  }
                  vm.offlineResourcesIter(products.data, cache_record.last_doc, resolve, cache_record);
                } else {
                  // se le risorse son già state scaricate in cache, risolvo subito la promise
                  resolve();
                }
              });

              resourcePromise.then((res) => {
                index++;
                // mi sono assicurato che tutte le risorse siano cachate, -> itero il prossimo catalogo
                this.offlineCatalogsIter(list, index);
              })
            } else {
              // le preferenze non prevedono che cachi alcuna risorsa, -> itero il prossimo catalogo
              index++;
              this.offlineCatalogsIter(list, index);
            }
          }
        }, (err) => {
          // se la promise viene respinta, qualcosa è andato storto nel caricamento del catalogo, riproverò a cachare al prossimo refresh (loaded_cat sarà ancora false)
          // -> itero il prossimo catalogo
          index++;
          this.offlineCatalogsIter(list, index);
        });

      }
    },
    offlineResourcesIter: function (products, index, resolve, cache_record) {
      if (index >= products.length) {
        // prima di risolvere la promise si scaricamento dell'intero catalogo, imposto il flag "in cache" a true
        cache_record.loaded_doc = true;
        this.$root.simpleNotification("success", {
          title: "",
          message: this.$Jed.firstUpperTranslate("index", null) + ' "' + cache_record.name + '" ' + this.$Jed.translate("successfully downloaded", null)
        })
        this.cache.update(cache_record);
        resolve();
      } else {
        // var array of products resources
        var resources = [];
        // definisco resources con l'insieme degli svgz / jpg / pdf relativi al prodotto che dovranno essere cachati
        var prod = products[index];
        if (prod.gra && prod.gra.length > 0) {
          for (var i = 0; i < prod.gra.length; i++) {
            if (prod.gra[i].sfn) {
              // SVGZ IMMAGINE
              resources.push(this.$root.getGraphic(prod.gra[i].sfn, "display", false));
            }
            if (prod.gra[i].tfn) {
              // ANTEPRIMA IMMAGINE
              resources.push(this.$root.getGraphic(prod.gra[i].sfn, "thumb", false));
            }

          }
        }
        if (this.$root.preferences.docProd) {
          // se è abilitato il flag di preferenza, cacho anche gli allegati
          if (prod.doc && prod.doc.length > 0) {
            var docs = prod.doc.slice();
            if (this.$root.preferences.docProdLang != "all") {
              var langs = this.$root.preferences.docProdLang.split(";")
              docs = docs.filter(function (d) {
                // il documento è accettabile quando è valido per ogni lingua (li == null) o per una delle lingue scelte (li == 'ITA')
                return !d.li || langs.indexOf(d.li) != -1;
              })
            }

            var path_src = this.$root.msPath + "/" + this.$Configs.licenseId + "/doc/src/";
            var path_pag = this.$root.msPath + "/" + this.$Configs.licenseId + "/doc/pag/";
            for (var i = 0; i < docs.length; i++) {
              var doc = docs[i];
              // PDF Documento
              resources.push(path_src + doc.na);
              var filename = null
              try {
                filename = doc.na.split(".").shift();
              } catch (err) {
                console.log("caught error on splitting filename")
                console.log(err)
              }
              if (doc.np && filename) {
                for (var ii = 0; ii < doc.np; ii++) {
                  var page = this.getPage(filename, ii, doc.np);
                  // pagina documento SVGZ
                  resources.push(path_pag + filename + '/' + page + '.svgz');
                  // anteprima pagina documento jpg
                  resources.push(path_pag + filename + '/' + page + '_tn.jpg');
                }
              }
            }
          }
        }

        //campiono 3 risorse caricate sparse nel catalogo, così da usarle in seguito come monitor per testarne la presenza in cache
        var third = Math.floor(products.length / 3)
        if (resources.length > 0) {
          if (cache_record["monitor"].length < 3) {
            if (cache_record["monitor"].length == 2) {
              // una risorsa dall'ultimo terzo
              if (index > (third * 2) && index < products.length) {
                cache_record["monitor"].push(resources[0]);
              }
            } else if (cache_record["monitor"].length == 1) {
              // secondo
              if (index > third && index < (third * 2)) {
                cache_record["monitor"].push(resources[0]);
              }
            } else {
              // primo
              if (index < third) {
                cache_record["monitor"] = [resources[0]];
              }
            }
          }

          // se c'è effettivamente qualche risorsa da cachare
          var vm = this;
          var rowResourcePromise = new Promise(function (row_resolve, row_reject) {
            vm.offlineRowResourcesIter(resources, 0, row_resolve);
          });
          // promise risolta a fine iter della riga di risorse prodotto
          rowResourcePromise.then((res) => {
            // a prescindere dal fatto che la promise vada a buon fine (o non venga creata perche non ci son risorse da scaricare), mi salvo la progressione della procedura
            cache_record.last_doc = index;
            this.cache.update(cache_record);
            index++;
            this.offlineResourcesIter(products, index, resolve, cache_record);
          })
        } else {
          cache_record.last_doc = index;
          this.cache.update(cache_record);
          index++;
          this.offlineResourcesIter(products, index, resolve, cache_record);
        }
      }
    },
    offlineRowResourcesIter: function (resources, index, resolve) {
      if (index >= resources.length) {
        // la promise si risolve a fine ricorsione, quando tutte le risorse della riga prodotto sono state scaricate
        resolve();
      } else {
        var resource = resources[index];
        if (resource) {
          // a prescindere dal fatto che la risorsa sia stata scaricata o meno, procedo con la ricorsione (e mi assicuro che la promise venga sempre risolta)
          this.$http.get(resource).then((res) => {
            index++;
            this.offlineRowResourcesIter(resources, index, resolve);
          }, (err) => {
            index++;
            this.offlineRowResourcesIter(resources, index, resolve);
          })
        } else {
          index++;
          this.offlineRowResourcesIter(resources, index, resolve);
        }
      }
    },
    getFigure4: function (n) {
      n = n.toString();
      var figures = n.length;
      var res = "";
      for (var i = 0; i < 4 - figures; i++) {
        res += "0"
      }
      res += n;
      return res;
    },
    getPage: function (name, npage, ntot) {
      console.log(npage)
      console.log(ntot)
      return name + "_p" + this.getFigure4(npage) + "-" + this.getFigure4(ntot);
    },
    cacheCollection: function () {
      var cache = this.$root.dataReferences.getCollection("indiceCache");
      if (!cache) {
        cache = this.$root.dataReferences.addCollection("indiceCache");
      }
      return cache;
    },
    cacheRecord: function (catalog) {
      var f = this.cache.find({
        "id": catalog.id,
        "version": catalog.version
      })
      console.log(f)
      if (!f || f.length == 0) {
        var new_record = {
          id: catalog.id,
          name: catalog.name,
          file: catalog.file,
          date: catalog.date,
          monitor: [],
          version: catalog.version,
          loaded_cat: false, // true quando è verificato che il loki del catalogo sia in cache
          loaded_doc: false, // true quando è verificato che le risorse previste dei prodotti del catalogo siano tutte in cache
          last_doc: 0 // riporta l'ultima riga nell'iter dei prodotti di cui son state cachate le risorse (rilevante solo quando loaded_doc == FALSE)
        }
        // NEW RECORD
        console.log("new record")
        return this.cache.insert(new_record)
      } else {
        // EXISTING RECORD
        console.log("existing record")
        return f[0];
      }
    },
    loadCatalog: function (cat) {
      var vm = this;
      return new Promise(function (resolve, reject) {
        vm.loadLoki(vm.$root.msPath + "/" + vm.$Configs.licenseId + "/cat/" + cat.file, "destructured", false, false).then((res) => {
          // verificato che il catalogo sia in cache
          console.log('dbCatalog loki db loaded', res)

          // se è la prima volta che carico il catalogo (!loaded_cat), e da preferenze non dico di dover scaricare altre risorse, mi assicuro di mostrare la notifica di scaricamento completato (solo catalogo in questo caso)
          if (!cat.loaded_cat && !vm.$root.preferences.docCat) {
            vm.$root.simpleNotification("success", {
              title: "",
              message: vm.$Jed.firstUpperTranslate("index", null) + ' "' + cat.name + '" ' + vm.$Jed.translate("successfully downloaded", null)
            })

          }
          cat.loaded_cat = true;
          // salvo il riferimento al catalogo per eventuale utilizzo offline
          if (vm.$root.root_index && Number(vm.$root.root_index) == cat.id) {
            vm.$root.dbCatalog = res;
          }
          vm.cache.update(cat);
          resolve(res)
        }, (err) => {
          console.log('error loadDatabase dbCatalog', err)
          reject(err)
        })
      });
    },
    resetCache: function () {
      this.$root.simpleNotification("info", {
        title: "DEV",
        message: "Cache impostata per reset",
      })
      if (this.cache != null && this.cache.data != null) {
        for (var i = 0; i < this.cache.data.length; i++) {
          this.resetRecord(this.cache.data[i]);
        }
      }
    },
    resetRecord: function (record) {
      record.loaded_cat = false;
      record.loaded_doc = false;
      record.last_doc = 0;
      record.monitor = [];
      this.cache.update(record)
    },
    startPolling: function () {
      var vm = this;
      setInterval(function () {
        vm.monitor();
      }, 15000)
    },
    monitor: function () {

      // console.log("MONITORING")
      var vm = this;
      var preferences = this.$root.preferences;
      if (preferences.useOffline && preferences.persistence == "Auto") {

        if (this.cache && this.cache.data) {
          var needDownload = false;
          for (let i = 0; i < this.cache.data.length; i++) {
            let record = this.cache.data[i];
            if (record.monitor && record.monitor.length > 0) {

              var pings = [];
              for (var ii = 0; ii < record.monitor.length; ii++) {
                pings.push(this.$http.get(record.monitor[ii]))
              }

              if (pings.length > 0) {
                Promise.all(pings).then((response) => {
                  for (var iii = 0; iii < response.length; iii++) {
                    var check = response[iii].headers.get("date")
                    var res_date = Date.parse(new Date(check));
                    var now_date = Date.now()
                    var diff = now_date - res_date;
                    if (diff > -2000 && diff < 2000) {
                      // 4 secondi di margine per stabilire se la risorsa era in cache ( l'header Date riporta la data della risposta da server, anche quando arriva dalla cache )
                      // le il margine è inferiore di 4 secondi, suppongo che la risposta sia stata inviata dal server
                      vm.resetRecord(record)
                      needDownload = true;
                    }
                  }
                  if (needDownload && navigator.onLine && (i >= vm.cache.data.length - 1)) {
                    // a fine ultima promise, se necessario, rieseguo la procedura di download
                    // in ogni caso riscaricherà solo i cataloghi "resettati"
                    vm.$root.simpleNotification("info", {
                      title: "",
                      message: vm.$Jed.firstUpperTranslate("index", null) + ' "' + record.name + '" ' + vm.$Jed.translate("missing in cache", null) + ', ' + vm.$Jed.translate("to be downloaded", null)
                    })
                    vm.START_DOWNLOAD();
                  }
                })
              }
            }
          }

        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/download_mixin.js